import { MAKEUP_V3_MENU_TABS } from '../utils/makeupV3MenuTabs';

export default function MakeupV3MenuTabs({
  activeTab,
  onChange,
  disabled = false,
  className = 'looks-studio__tabs',
  tabClassName = 'looks-studio__tab',
}) {
  return (
    <nav className={className} aria-label="Makeup menu">
      {MAKEUP_V3_MENU_TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`${tabClassName}${activeTab === t.id ? ' is-active' : ''}`}
          disabled={disabled}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
